import find from 'lodash/find';

/**
 * Find current flex package line item
 * from an array of line items.
 */
export function getCurrentFlexPackage(packageItems, perfNo) {
    return find(packageItems, function (item) {
        return (
            item.flex_ind === 'Y' &&
            parseInt(item.perf_no, 10) === perfNo
        );
    });
}

/**
 * Find current fixed package line item
 * from an array of line items.
 */
export function getCurrentFixedPackage(packageItems, pkgNo) {
    return find(packageItems, function (item) {
        return (
            item.fixed_seat_ind === 'Y' &&
            parseInt(item.pkg_no, 10) === pkgNo
        );
    });
}

export function getCurrentFixedPackagePerf(packageItems) {
    return find(packageItems, function (item) {
        return (
            item.fixed_seat_ind === 'Y' &&
            parseInt(item.perf_no, 10) === 0
        );
    });
}

export default {
    getCurrentFlexPackage,
    getCurrentFixedPackage,
    getCurrentFixedPackagePerf
}



// WEBPACK FOOTER //
// ./src/javascripts/app/lib/cart/packages.js